import React, { FC } from "react";
import CommonModal from "../components/commonModal";
import ModalButtons from "./shared/modalButtons";
import useModalState from "./hooks/useModalState";
import { SelectOption } from "../../../models/selectOption";
import { ConfirmInputGroup } from "./shared/confirmInputGroup";

const getError = (id: string, message: string): string => {
  return !id || !message ? "Please select a group and enter a note to resend case" : "";
};

interface Props {
  show: boolean;
  handleClose: () => void;
  handleSave: (groupId: number, message: string) => void;
  groups: SelectOption[];
}

export const ResendCaseToOtherGroupModal: FC<Props> = ({ show = false, handleClose, handleSave, groups }) => {
  const { close, errorComponent, id, message, save, setId, setMessage } = useModalState(
    handleClose,
    handleSave,
    getError
  );

  return (
    <CommonModal
      show={show}
      title="Change Case Group and if required, Resend Case"
      onHide={close}
      buttons={<ModalButtons close={close} save={save} saveLabel="Change Group" />}
    >
      <p>
        Please select the group you would like to change this case to. The actions associated with the group will be applied.
      </p>
      {errorComponent}
      {groups.length > 0 ? (
        <ConfirmInputGroup
          choices={groups.map((group: SelectOption) => {
            return {
              id: group.id,
              label: group.label,
            };
          })}
          handleIdChange={setId}
          handleNoteChange={setMessage}
          id={id ? id : ""}
          note={message}
          title="Group"
          placeholder="Select Group"
        />
      ) : (
        <p>No groups available to resend to.</p>
      )}
    </CommonModal>
  );
};
